import type { Component } from "vue";
import {
  ActivityIcon,
  AppWindowIcon,
  ArchiveIcon,
  ArchiveRestoreIcon,
  ArrowDownAZIcon,
  ArrowDownIcon,
  ArrowDownNarrowWideIcon,
  ArrowDownToLineIcon,
  ArrowDownUpIcon,
  ArrowDownWideNarrowIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowRightLeftIcon,
  ArrowUpIcon,
  ArrowUpToLineIcon,
  ArrowUpWideNarrowIcon,
  AsteriskIcon,
  AtSignIcon,
  BabyIcon,
  BanIcon,
  BanknoteIcon,
  BarcodeIcon,
  BedIcon,
  BellIcon,
  BellOffIcon,
  BellRingIcon,
  BookIcon,
  BookmarkIcon,
  BotIcon,
  BoxesIcon,
  BoxIcon,
  BracesIcon,
  BriefcaseIcon,
  BriefcaseMedicalIcon,
  BroomIcon,
  BrushIcon,
  BugIcon,
  BuildingComplexIcon,
  BuildingIcon,
  CalculatorIcon,
  Calendar1Icon,
  CalendarCheckIcon,
  CalendarClockIcon,
  CalendarDaysIcon,
  CalendarIcon,
  CalendarPlusIcon,
  CalendarRangeIcon,
  CalendarXIcon,
  CameraIcon,
  CaptionsIcon,
  ChartBarIcon,
  ChartGanttIcon,
  ChartLineIcon,
  ChartNoAxesColumnIcon,
  ChartPieIcon,
  CheckCheckIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronsDownUpIcon,
  ChevronsUpDownIcon,
  ChevronUpIcon,
  CircleAlertIcon,
  CircleCheckIcon,
  CircleDotIcon,
  CircleIcon,
  CircleMinusIcon,
  CirclePauseIcon,
  CirclePlayIcon,
  CirclePlusIcon,
  CircleQuestionMarkIcon,
  CircleSlash2Icon,
  CircleStopIcon,
  CircleXIcon,
  ClipboardCheckIcon,
  ClipboardIcon,
  ClipboardListIcon,
  ClockIcon,
  CloudCheckIcon,
  CloudDownloadIcon,
  CloudUploadIcon,
  CodeIcon,
  CoffeeIcon,
  CogIcon,
  CoinsIcon,
  ConciergeBellIcon,
  ContactIcon,
  ContrastIcon,
  CopyIcon,
  CreditCardIcon,
  DatabaseIcon,
  DiffIcon,
  DoorClosedIcon,
  DoorOpenIcon,
  DownloadIcon,
  DramaIcon,
  EclipseIcon,
  EllipsisIcon,
  EllipsisVerticalIcon,
  ExpandIcon,
  ExternalLinkIcon,
  EyeIcon,
  EyeOffIcon,
  FaceSlightlySmilingIcon,
  FastForwardIcon,
  FaucetIcon,
  FileArchiveIcon,
  FileExclamationPointIcon,
  FileIcon,
  FileInputIcon,
  FileOutputIcon,
  FileQuestionMarkIcon,
  FileSpreadsheetIcon,
  FileTextIcon,
  FileVideoCameraIcon,
  FireExtinguisherIcon,
  FlagIcon,
  FlaskConicalIcon,
  FolderIcon,
  FolderOpenIcon,
  FoldVerticalIcon,
  ForkliftIcon,
  FunnelIcon,
  FunnelXIcon,
  GaugeIcon,
  GitBranchIcon,
  GlobeIcon,
  Grid3x3Icon,
  GripVerticalIcon,
  GroupIcon,
  HamburgerIcon,
  HammerIcon,
  HandIcon,
  HardDriveIcon,
  HashIcon,
  HeadsetIcon,
  HourglassIcon,
  HouseIcon,
  HousesIcon,
  IceCreamConeIcon,
  IdCardIcon,
  ImageIcon,
  ImageOffIcon,
  ImagesIcon,
  InboxIcon,
  InfoIcon,
  KeyboardIcon,
  KeyIcon,
  KeyRoundIcon,
  LanguagesIcon,
  LaptopIcon,
  LayersIcon,
  LayoutDashboardIcon,
  LayoutGridIcon,
  LeafIcon,
  LibraryBigIcon,
  LifeBuoyIcon,
  LinkIcon,
  ListCheckIcon,
  ListChecksIcon,
  ListIcon,
  ListOrderedIcon,
  ListTreeIcon,
  LoaderCircleIcon,
  LoaderIcon,
  LocateFixedIcon,
  LockIcon,
  LockOpenIcon,
  LogInIcon,
  LogOutIcon,
  MailIcon,
  MailOpenIcon,
  MapPinIcon,
  MenuIcon,
  MessageCircleIcon,
  MessageCircleMoreIcon,
  MessageCircleOffIcon,
  MessageCirclePlusIcon,
  MessageSquareTextIcon,
  MessagesSquareIcon,
  MinusIcon,
  MonitorIcon,
  MonitorSmartphoneIcon,
  MoonIcon,
  MousePointerIcon,
  MoveHorizontalIcon,
  NetworkIcon,
  NotepadTextIcon,
  PackageCheckIcon,
  PackageIcon,
  PackageOpenIcon,
  PaletteIcon,
  PaperclipIcon,
  PartyPopperIcon,
  PauseIcon,
  PawPrintIcon,
  PencilIcon,
  PenIcon,
  PercentIcon,
  PersonStandingIcon,
  PhoneIcon,
  PinIcon,
  PinOffIcon,
  PlaneLandingIcon,
  PlaneTakeoffIcon,
  PlayIcon,
  PlugIcon,
  PlusIcon,
  PointerIcon,
  PowerOffIcon,
  PresentationIcon,
  PrinterIcon,
  PuzzleIcon,
  QrCodeIcon,
  ReceiptEuroIcon,
  ReceiptIcon,
  ReceiptTextIcon,
  RedoIcon,
  RefreshCwIcon,
  Repeat2Icon,
  RepeatIcon,
  RocketIcon,
  RotateCcwClockIcon,
  RotateCcwIcon,
  RotateCwIcon,
  RouteIcon,
  RulerDimensionLineIcon,
  SaveIcon,
  SearchIcon,
  SendIcon,
  ServerIcon,
  ShapesIcon,
  Share2Icon,
  ShareIcon,
  ShieldAlertIcon,
  ShieldCheckIcon,
  ShieldHalfIcon,
  ShieldIcon,
  ShieldPlusIcon,
  ShieldXIcon,
  ShirtIcon,
  ShoppingCartIcon,
  ShovelIcon,
  ShowerHeadIcon,
  ShuffleIcon,
  SignalIcon,
  SlidersHorizontalIcon,
  SmartphoneIcon,
  SnowflakeIcon,
  SoapDispenserDropletIcon,
  SparklesIcon,
  SprayCanIcon,
  SproutIcon,
  SquareCheckIcon,
  SquareFunctionIcon,
  SquareIcon,
  SquarePenIcon,
  StarIcon,
  StickyNotesIcon,
  StoreIcon,
  SunIcon,
  TabletIcon,
  TagIcon,
  TagsIcon,
  TerminalIcon,
  TextAlignStartIcon,
  TextCursorInputIcon,
  ThermometerIcon,
  TimerIcon,
  ToggleRightIcon,
  ToolboxIcon,
  ToolCaseIcon,
  TractorIcon,
  TrashIcon,
  TreeDeciduousIcon,
  TriangleAlertIcon,
  TruckIcon,
  TypeIcon,
  Undo2Icon,
  UndoIcon,
  UnfoldVerticalIcon,
  UnlinkIcon,
  UploadIcon,
  UserCheckIcon,
  UserCogIcon,
  UserGroupIcon,
  UserIcon,
  UserPenIcon,
  UserPlusIcon,
  UserRoundCheckIcon,
  UserRoundCogIcon,
  UserRoundPenIcon,
  UserShieldIcon,
  UsersIcon,
  UsersRoundIcon,
  UserXIcon,
  UtensilsIcon,
  VenetianMaskIcon,
  VolleyballIcon,
  Volume2Icon,
  VolumeXIcon,
  WandIcon,
  WandSparklesIcon,
  WarehouseIcon,
  WavesHorizontalIcon,
  WavesLadderIcon,
  WebhookIcon,
  WifiIcon,
  WrenchIcon,
  XIcon,
  ZapIcon,
} from "@lucide/vue";
import { BrandAndroidIcon, BrandAppleIcon, BrandIdealIcon, GolfCartIcon } from "./customIcons";

/**
 * Every icon the app can draw, by name. The names are Lucide's own, plus a few custom icons (`brand-*`, `golf-cart`).
 * Only the icons listed here end up in the bundle: add a name here before using it with `VIcon`.
 */
export const icons = {
  "activity": ActivityIcon,
  "app-window": AppWindowIcon,
  "archive": ArchiveIcon,
  "archive-restore": ArchiveRestoreIcon,
  "arrow-down": ArrowDownIcon,
  "arrow-down-a-z": ArrowDownAZIcon,
  "arrow-down-narrow-wide": ArrowDownNarrowWideIcon,
  "arrow-down-to-line": ArrowDownToLineIcon,
  "arrow-down-up": ArrowDownUpIcon,
  "arrow-down-wide-narrow": ArrowDownWideNarrowIcon,
  "arrow-left": ArrowLeftIcon,
  "arrow-right": ArrowRightIcon,
  "arrow-right-left": ArrowRightLeftIcon,
  "arrow-up": ArrowUpIcon,
  "arrow-up-to-line": ArrowUpToLineIcon,
  "arrow-up-wide-narrow": ArrowUpWideNarrowIcon,
  "asterisk": AsteriskIcon,
  "at-sign": AtSignIcon,
  "baby": BabyIcon,
  "ban": BanIcon,
  "banknote": BanknoteIcon,
  "barcode": BarcodeIcon,
  "bed": BedIcon,
  "bell": BellIcon,
  "bell-off": BellOffIcon,
  "bell-ring": BellRingIcon,
  "book": BookIcon,
  "bookmark": BookmarkIcon,
  "bot": BotIcon,
  "box": BoxIcon,
  "boxes": BoxesIcon,
  "braces": BracesIcon,
  "brand-android": BrandAndroidIcon,
  "brand-apple": BrandAppleIcon,
  "brand-ideal": BrandIdealIcon,
  "briefcase": BriefcaseIcon,
  "briefcase-medical": BriefcaseMedicalIcon,
  "broom": BroomIcon,
  "brush": BrushIcon,
  "bug": BugIcon,
  "building": BuildingIcon,
  "building-complex": BuildingComplexIcon,
  "calculator": CalculatorIcon,
  "calendar": CalendarIcon,
  "calendar-1": Calendar1Icon,
  "calendar-check": CalendarCheckIcon,
  "calendar-clock": CalendarClockIcon,
  "calendar-days": CalendarDaysIcon,
  "calendar-plus": CalendarPlusIcon,
  "calendar-range": CalendarRangeIcon,
  "calendar-x": CalendarXIcon,
  "camera": CameraIcon,
  "captions": CaptionsIcon,
  "chart-bar": ChartBarIcon,
  "chart-gantt": ChartGanttIcon,
  "chart-line": ChartLineIcon,
  "chart-no-axes-column": ChartNoAxesColumnIcon,
  "chart-pie": ChartPieIcon,
  "check": CheckIcon,
  "check-check": CheckCheckIcon,
  "chevron-down": ChevronDownIcon,
  "chevron-left": ChevronLeftIcon,
  "chevron-right": ChevronRightIcon,
  "chevron-up": ChevronUpIcon,
  "chevrons-down-up": ChevronsDownUpIcon,
  "chevrons-up-down": ChevronsUpDownIcon,
  "circle": CircleIcon,
  "circle-alert": CircleAlertIcon,
  "circle-check": CircleCheckIcon,
  "circle-dot": CircleDotIcon,
  "circle-minus": CircleMinusIcon,
  "circle-pause": CirclePauseIcon,
  "circle-play": CirclePlayIcon,
  "circle-plus": CirclePlusIcon,
  "circle-question-mark": CircleQuestionMarkIcon,
  "circle-slash-2": CircleSlash2Icon,
  "circle-stop": CircleStopIcon,
  "circle-x": CircleXIcon,
  "clipboard": ClipboardIcon,
  "clipboard-check": ClipboardCheckIcon,
  "clipboard-list": ClipboardListIcon,
  "clock": ClockIcon,
  "cloud-check": CloudCheckIcon,
  "cloud-download": CloudDownloadIcon,
  "cloud-upload": CloudUploadIcon,
  "code": CodeIcon,
  "coffee": CoffeeIcon,
  "cog": CogIcon,
  "coins": CoinsIcon,
  "concierge-bell": ConciergeBellIcon,
  "contact": ContactIcon,
  "contrast": ContrastIcon,
  "copy": CopyIcon,
  "credit-card": CreditCardIcon,
  "database": DatabaseIcon,
  "diff": DiffIcon,
  "door-closed": DoorClosedIcon,
  "door-open": DoorOpenIcon,
  "download": DownloadIcon,
  "drama": DramaIcon,
  "eclipse": EclipseIcon,
  "ellipsis": EllipsisIcon,
  "ellipsis-vertical": EllipsisVerticalIcon,
  "expand": ExpandIcon,
  "external-link": ExternalLinkIcon,
  "eye": EyeIcon,
  "eye-off": EyeOffIcon,
  "face-slightly-smiling": FaceSlightlySmilingIcon,
  "fast-forward": FastForwardIcon,
  "faucet": FaucetIcon,
  "file": FileIcon,
  "file-archive": FileArchiveIcon,
  "file-exclamation-point": FileExclamationPointIcon,
  "file-input": FileInputIcon,
  "file-output": FileOutputIcon,
  "file-question-mark": FileQuestionMarkIcon,
  "file-spreadsheet": FileSpreadsheetIcon,
  "file-text": FileTextIcon,
  "file-video-camera": FileVideoCameraIcon,
  "fire-extinguisher": FireExtinguisherIcon,
  "flag": FlagIcon,
  "flask-conical": FlaskConicalIcon,
  "fold-vertical": FoldVerticalIcon,
  "folder": FolderIcon,
  "folder-open": FolderOpenIcon,
  "forklift": ForkliftIcon,
  "funnel": FunnelIcon,
  "funnel-x": FunnelXIcon,
  "gauge": GaugeIcon,
  "git-branch": GitBranchIcon,
  "globe": GlobeIcon,
  "golf-cart": GolfCartIcon,
  "grid-3x3": Grid3x3Icon,
  "grip-vertical": GripVerticalIcon,
  "group": GroupIcon,
  "hamburger": HamburgerIcon,
  "hammer": HammerIcon,
  "hand": HandIcon,
  "hard-drive": HardDriveIcon,
  "hash": HashIcon,
  "headset": HeadsetIcon,
  "hourglass": HourglassIcon,
  "house": HouseIcon,
  "houses": HousesIcon,
  "ice-cream-cone": IceCreamConeIcon,
  "id-card": IdCardIcon,
  "image": ImageIcon,
  "image-off": ImageOffIcon,
  "images": ImagesIcon,
  "inbox": InboxIcon,
  "info": InfoIcon,
  "key": KeyIcon,
  "key-round": KeyRoundIcon,
  "keyboard": KeyboardIcon,
  "languages": LanguagesIcon,
  "laptop": LaptopIcon,
  "layers": LayersIcon,
  "layout-dashboard": LayoutDashboardIcon,
  "layout-grid": LayoutGridIcon,
  "leaf": LeafIcon,
  "library-big": LibraryBigIcon,
  "life-buoy": LifeBuoyIcon,
  "link": LinkIcon,
  "list": ListIcon,
  "list-check": ListCheckIcon,
  "list-checks": ListChecksIcon,
  "list-ordered": ListOrderedIcon,
  "list-tree": ListTreeIcon,
  "loader": LoaderIcon,
  "loader-circle": LoaderCircleIcon,
  "locate-fixed": LocateFixedIcon,
  "lock": LockIcon,
  "lock-open": LockOpenIcon,
  "log-in": LogInIcon,
  "log-out": LogOutIcon,
  "mail": MailIcon,
  "mail-open": MailOpenIcon,
  "map-pin": MapPinIcon,
  "menu": MenuIcon,
  "message-circle": MessageCircleIcon,
  "message-circle-more": MessageCircleMoreIcon,
  "message-circle-off": MessageCircleOffIcon,
  "message-circle-plus": MessageCirclePlusIcon,
  "message-square-text": MessageSquareTextIcon,
  "messages-square": MessagesSquareIcon,
  "minus": MinusIcon,
  "monitor": MonitorIcon,
  "monitor-smartphone": MonitorSmartphoneIcon,
  "moon": MoonIcon,
  "mouse-pointer": MousePointerIcon,
  "move-horizontal": MoveHorizontalIcon,
  "network": NetworkIcon,
  "notepad-text": NotepadTextIcon,
  "package": PackageIcon,
  "package-check": PackageCheckIcon,
  "package-open": PackageOpenIcon,
  "palette": PaletteIcon,
  "paperclip": PaperclipIcon,
  "party-popper": PartyPopperIcon,
  "pause": PauseIcon,
  "paw-print": PawPrintIcon,
  "pen": PenIcon,
  "pencil": PencilIcon,
  "percent": PercentIcon,
  "person-standing": PersonStandingIcon,
  "phone": PhoneIcon,
  "pin": PinIcon,
  "pin-off": PinOffIcon,
  "plane-landing": PlaneLandingIcon,
  "plane-takeoff": PlaneTakeoffIcon,
  "play": PlayIcon,
  "plug": PlugIcon,
  "plus": PlusIcon,
  "pointer": PointerIcon,
  "power-off": PowerOffIcon,
  "presentation": PresentationIcon,
  "printer": PrinterIcon,
  "puzzle": PuzzleIcon,
  "qr-code": QrCodeIcon,
  "receipt": ReceiptIcon,
  "receipt-euro": ReceiptEuroIcon,
  "receipt-text": ReceiptTextIcon,
  "redo": RedoIcon,
  "refresh-cw": RefreshCwIcon,
  "repeat": RepeatIcon,
  "repeat-2": Repeat2Icon,
  "rocket": RocketIcon,
  "rotate-ccw": RotateCcwIcon,
  "rotate-ccw-clock": RotateCcwClockIcon,
  "rotate-cw": RotateCwIcon,
  "route": RouteIcon,
  "ruler-dimension-line": RulerDimensionLineIcon,
  "save": SaveIcon,
  "search": SearchIcon,
  "send": SendIcon,
  "server": ServerIcon,
  "shapes": ShapesIcon,
  "share": ShareIcon,
  "share-2": Share2Icon,
  "shield": ShieldIcon,
  "shield-alert": ShieldAlertIcon,
  "shield-check": ShieldCheckIcon,
  "shield-half": ShieldHalfIcon,
  "shield-plus": ShieldPlusIcon,
  "shield-x": ShieldXIcon,
  "shirt": ShirtIcon,
  "shopping-cart": ShoppingCartIcon,
  "shovel": ShovelIcon,
  "shower-head": ShowerHeadIcon,
  "shuffle": ShuffleIcon,
  "signal": SignalIcon,
  "sliders-horizontal": SlidersHorizontalIcon,
  "smartphone": SmartphoneIcon,
  "snowflake": SnowflakeIcon,
  "soap-dispenser-droplet": SoapDispenserDropletIcon,
  "sparkles": SparklesIcon,
  "spray-can": SprayCanIcon,
  "sprout": SproutIcon,
  "square": SquareIcon,
  "square-check": SquareCheckIcon,
  "square-function": SquareFunctionIcon,
  "square-pen": SquarePenIcon,
  "star": StarIcon,
  "sticky-notes": StickyNotesIcon,
  "store": StoreIcon,
  "sun": SunIcon,
  "tablet": TabletIcon,
  "tag": TagIcon,
  "tags": TagsIcon,
  "terminal": TerminalIcon,
  "text-align-start": TextAlignStartIcon,
  "text-cursor-input": TextCursorInputIcon,
  "thermometer": ThermometerIcon,
  "timer": TimerIcon,
  "toggle-right": ToggleRightIcon,
  "tool-case": ToolCaseIcon,
  "toolbox": ToolboxIcon,
  "tractor": TractorIcon,
  "trash": TrashIcon,
  "tree-deciduous": TreeDeciduousIcon,
  "triangle-alert": TriangleAlertIcon,
  "truck": TruckIcon,
  "type": TypeIcon,
  "undo": UndoIcon,
  "undo-2": Undo2Icon,
  "unfold-vertical": UnfoldVerticalIcon,
  "unlink": UnlinkIcon,
  "upload": UploadIcon,
  "user": UserIcon,
  "user-check": UserCheckIcon,
  "user-cog": UserCogIcon,
  "user-group": UserGroupIcon,
  "user-pen": UserPenIcon,
  "user-plus": UserPlusIcon,
  "user-round-check": UserRoundCheckIcon,
  "user-round-cog": UserRoundCogIcon,
  "user-round-pen": UserRoundPenIcon,
  "user-shield": UserShieldIcon,
  "user-x": UserXIcon,
  "users": UsersIcon,
  "users-round": UsersRoundIcon,
  "utensils": UtensilsIcon,
  "venetian-mask": VenetianMaskIcon,
  "volleyball": VolleyballIcon,
  "volume-2": Volume2Icon,
  "volume-x": VolumeXIcon,
  "wand": WandIcon,
  "wand-sparkles": WandSparklesIcon,
  "warehouse": WarehouseIcon,
  "waves-horizontal": WavesHorizontalIcon,
  "waves-ladder": WavesLadderIcon,
  "webhook": WebhookIcon,
  "wifi": WifiIcon,
  "wrench": WrenchIcon,
  "x": XIcon,
  "zap": ZapIcon,
} satisfies Record<string, Component>;

/** The name of an icon in {@link icons}. */
export type IconName = keyof typeof icons;

/** Whether a value read at runtime (an item field, a route meta) is the name of an icon in {@link icons}. */
export function isIconName(value: unknown): value is IconName {
  return typeof value === "string" && Object.hasOwn(icons, value);
}
